import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import BrandLogo from "@/components/BrandLogo";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Welcome to Maharlika family!");
      navigate("/account");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6] px-4 py-10" data-testid="register-page">
      <div className="w-full max-w-md mart-card p-8">
        <div className="flex justify-center mb-5">
          <div className="w-20 h-20 rounded-full bg-[#050505] flex items-center justify-center"><BrandLogo type="register" size="md" showText={false} /></div>
        </div>
        <h1 className="font-heading text-3xl text-[#1A2421] text-center">Join the Royal Family</h1>
        <p className="text-center text-[#5C6B64] text-sm mb-5">Earn rewards, save favorites, track orders.</p>
        <form onSubmit={submit} className="space-y-3">
          <input required placeholder="Full name" data-testid="reg-name" className="w-full border border-[#8A9A86]/40 rounded px-4 py-3" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})}/>
          <input required type="email" placeholder="Email" data-testid="reg-email" className="w-full border border-[#8A9A86]/40 rounded px-4 py-3" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})}/>
          <input placeholder="Phone (optional)" data-testid="reg-phone" className="w-full border border-[#8A9A86]/40 rounded px-4 py-3" value={form.phone} onChange={(e) => setForm({...form, phone: e.target.value})}/>
          <input required type="password" placeholder="Password (min 6)" data-testid="reg-password" className="w-full border border-[#8A9A86]/40 rounded px-4 py-3" value={form.password} onChange={(e) => setForm({...form, password: e.target.value})}/>
          <button data-testid="reg-submit" disabled={loading} className="btn-mart w-full py-3">{loading ? "Creating..." : "Create account"}</button>
        </form>
        <p className="text-sm text-[#5C6B64] mt-4 text-center">Already have an account? <Link to="/login" className="text-[#2C4A3B] font-semibold">Sign in</Link></p>
      </div>
    </div>
  );
}
